module.exports = __webpack_public_path__ + "static/weather-clear-sky-night.476485e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather/weather-clear-sky-night.svg
// module id = 143
// module chunks = 83392758035670 156754302151026